(function () {
    'use strict';

    angular.module('modules.policies', ['plugins.lodash', 'blocks.helpers', 'angularMoment']);
})();
